import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Stack } from '@mui/material';

import { FilesInput, UploadedFiles } from '../../../common/file_input';
import { getFoodPartnerOrderAttachmentAction, getFoodPartnerOrderAttachmentState } from '../../../../features/inventory/get_food_partner_order_attachment';
import { getFoodPartnerOrderAttachmentNotificationData } from '../../../../core/utils/notification_utils';
import useNotification from '../../../../core/hooks/use_notification';

const UploadFiles = ({ formik, downloadOption, addAndRemoveOptions }) => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();

    const generateFoodPartnerOrderAttachment = useSelector(getFoodPartnerOrderAttachmentState);
    const attachments = formik?.values?.attachments || [];

    if (!addAndRemoveOptions && attachments.length === 0) {
        return null;
    }

    const onAttachFile = (fileArray) => {
        const newFiles = [...attachments] || [];
        fileArray.forEach(file => newFiles.push(file));

        formik.setFieldValue('attachments', newFiles);
    };

    const onRemoveFile = (id) => {
        const attachmentIdsToDelete = formik?.values?.attachmentIdsToDelete ? [...formik?.values?.attachmentIdsToDelete] : [];
        const newFiles = [...formik?.values?.attachments];
        const attachment = newFiles.splice(id, 1)[0];

        formik.setFieldValue('attachments', newFiles);
        attachment?.id && attachmentIdsToDelete.push(attachment?.id);
        formik.setFieldValue('attachmentIdsToDelete', attachmentIdsToDelete);
    };

    const ondDownloadClick = (fileUrl) => {
        dispatch(getFoodPartnerOrderAttachmentAction(fileUrl))
            .then(response => showErrorMessage(getFoodPartnerOrderAttachmentNotificationData(response)));
    };

    return (
        <Box sx={ { width: '100%', mt: 2 } }>
            <Stack spacing={ 4 }>
                {
                    addAndRemoveOptions && (
                        <Box>
                            <FilesInput
                                label="Załączniki do maila"
                                text="Dodaj lub przeciągnij plik"
                                onAttach={ onAttachFile }
                                maxFiles={ 3 }
                                acceptedFileExtensions={ ['xls', 'xlsx', 'pdf', 'doc', 'docx', 'csv', 'txt'] }
                                maxTotalFilesSizeInMB={ 15 }
                                uploadedFiles={ attachments }
                            />
                        </Box>
                    )
                }

                <Box>
                    <UploadedFiles
                        uploadedFiles={ attachments }
                        onRemove={ onRemoveFile }
                        label="Załączone pliki"
                        downloadOption={ downloadOption }
                        ondDownloadClick={ ondDownloadClick }
                        isLoading={ generateFoodPartnerOrderAttachment?.loading }
                        removeOption={ addAndRemoveOptions }
                    />
                </Box>
            </Stack>
        </Box>
    );
};

export default UploadFiles;